export const CAMPUS_GUIDE_LOAD = 'CAMPUS_GUIDE_LOAD';

export const sessionInit = payload => ({
  type: CAMPUS_GUIDE_LOAD,
  payload
});
